"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const core_1 = require("@material-ui/core");
const Search_1 = (0, tslib_1.__importDefault)(require("@material-ui/icons/Search"));
const Clear_1 = (0, tslib_1.__importDefault)(require("@material-ui/icons/Clear"));
const lodash_1 = require("lodash");
const infra_1 = require("@monorepo/infra");
const CssTextField = (0, core_1.withStyles)({
    root: {
        '& .MuiInputBase-root': {
            'font-family': 'PFDINText',
            'font-size': '15px',
            'font-style': 'normal',
            'font-weight': '500',
            'line-height': '16px',
        },
    },
})(core_1.TextField);
const DebounceInput = ({ name = undefined, length = undefined, wait = undefined, onChange = undefined, fullWidth = false, placeholder = undefined, searchIcon = false, searchIconPosition = 'start', clearIcon = false, clearIconPosition = 'end', disabled = undefined, autoFocus = undefined, variant = undefined, }) => {
    const [value, setValue] = (0, react_1.useState)('');
    const delayCall = (0, react_1.useRef)((0, lodash_1.debounce)((value, name, onChange) => {
        if (!isNaN(length) &&
            (0, infra_1.isString)(value) &&
            value.length > 0 &&
            value.length < length) {
            return;
        }
        if ((0, infra_1.isFunction)(onChange)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(value, name);
        }
    }, wait)).current;
    const handleChange = (value) => {
        setValue(value);
        delayCall(value, name, onChange);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            delayCall.cancel();
        };
    }, [delayCall]);
    return ((0, jsx_runtime_1.jsx)(CssTextField, { value: value, onChange: ({ target: { value } }) => handleChange(value), fullWidth: fullWidth, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, variant: variant, InputProps: Object.assign({}, ((searchIcon || clearIcon) && {
            startAdornment: (searchIcon && searchIconPosition === 'start') ||
                (clearIcon && clearIconPosition === 'start') ? ((0, jsx_runtime_1.jsx)(core_1.InputAdornment, Object.assign({ position: "start" }, { children: searchIcon ? ((0, jsx_runtime_1.jsx)(Search_1.default, { onClick: () => handleChange(value), style: { cursor: 'pointer' } }, void 0)) : clearIcon ? ((0, jsx_runtime_1.jsx)(Clear_1.default, { onClick: () => handleChange(''), style: { cursor: 'pointer' } }, void 0)) : null }), void 0)) : null,
            endAdornment: (searchIcon && searchIconPosition === 'end') ||
                (clearIcon && clearIconPosition === 'end') ? ((0, jsx_runtime_1.jsx)(core_1.InputAdornment, Object.assign({ position: "end" }, { children: searchIcon ? ((0, jsx_runtime_1.jsx)(Search_1.default, { onClick: () => handleChange(value), style: { cursor: 'pointer' } }, void 0)) : clearIcon ? ((0, jsx_runtime_1.jsx)(Clear_1.default, { onClick: () => handleChange(''), style: { cursor: 'pointer' } }, void 0)) : null }), void 0)) : null,
        })) }, void 0));
};
exports.default = DebounceInput;
